export const RecaptchaLowScoreErrorResponse = 'Recaptcha score is lower than threshold'
export const RecaptchaVerificationErrorResponse = 'Recaptcha verification failed'

export const isRecapthcaLowScoreError = (errorMessage: string): boolean => {
  return errorMessage === RecaptchaLowScoreErrorResponse
}

export const isRecapthcaVerificationError = (errorMessage: string): boolean => {
  return errorMessage === RecaptchaVerificationErrorResponse
}
